"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContracts = getContracts;
exports.getSellersForSku = getSellersForSku;
exports.bulkEval = bulkEval;
exports.doBulkEvaluatePriceModel = exports.doBulkEvaluateContracts = exports.NO_CONTRACTS_OR_LISTPRICE_MESSAGE = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _fulfillerIdentity = require("./fulfillerIdentity");

var _util = require("./util");
/* eslint import/prefer-default-export: "off" */


var productionUrl = 'https://productprice.financialflows.cimpress.io';
var stgUrl = 'https://stg-productprice.financialflows.cimpress.io';
var NO_CONTRACTS_OR_LISTPRICE_MESSAGE = 'No contracts nor list price configured';
exports.NO_CONTRACTS_OR_LISTPRICE_MESSAGE = NO_CONTRACTS_OR_LISTPRICE_MESSAGE;

function getContracts(mcpSku, onGetAccessToken, isProduction) {
  var fulfillerId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var accessToken = onGetAccessToken();
  var headers = new Headers({
    Accept: 'application/json',
    Authorization: "Bearer ".concat(accessToken)
  });
  var options = {
    method: 'GET',
    mode: 'cors',
    headers: headers
  };
  var productPriceUrl = isProduction ? productionUrl : stgUrl;
  return fetch("".concat(productPriceUrl, "/api/v2/priceStatus/").concat(mcpSku), options).then(function (res) {
    if (res.ok) {
      return res.json();
    }

    throw res;
  }).then(function (res) {
    var relationships = res.relationships;
    var contracts = [];
    var listPriceModelInfo = null;

    if (relationships && relationships.length) {
      for (var i = 0; i < relationships.length; i += 1) {
        var relationship = relationships[i];

        if (relationship.seller.sellerId === fulfillerId) {
          if (relationship.buyer.buyerId === '*') {
            var priceModelId = relationship.priceModelId,
                priceModelRevisionId = relationship.priceModelRevisionId;
            listPriceModelInfo = {
              priceModelId: priceModelId,
              revisionId: priceModelRevisionId
            };
          } else {
            contracts.push({
              buyer: relationship.buyer,
              seller: relationships[i].seller
            });
          }
        }
      }

      return {
        contracts: contracts,
        listPriceModelInfo: listPriceModelInfo
      };
    }

    return [];
  });
}

function createDefaultSellers(sellers) {
  return sellers.map(function (seller) {
    return {
      value: seller,
      label: seller
    };
  });
}

function getSellersForSku(mcpSku, onGetAccessToken, isProduction, sellerId) {
  var accessToken = onGetAccessToken();
  var headers = new Headers({
    Accept: 'application/json',
    Authorization: "Bearer ".concat(accessToken)
  });
  var options = {
    method: 'GET',
    mode: 'cors',
    headers: headers
  };
  var productPriceUrl = isProduction ? productionUrl : stgUrl;
  return fetch("".concat(productPriceUrl, "/api/v2/priceStatus/").concat(mcpSku), options).then(function (res) {
    if (res.ok) {
      return res.json();
    }

    throw res;
  }).then(function (res) {
    if (res.relationships && res.relationships.length) {
      var allSellers = res.relationships.map(function (relationship) {
        return relationship.seller ? relationship.seller.sellerId : null;
      }).filter(function (seller) {
        return seller;
      });
      return (0, _toConsumableArray2.default)(new Set(allSellers));
    }

    return [];
  }).then(function (sellers) {
    if (sellerId) {
      return createDefaultSellers(sellers);
    }

    return (0, _fulfillerIdentity.getFulfillers)(sellers, onGetAccessToken).then(function (fulfillers) {
      return fulfillers.fulfillers.map(function (fulfiller, index) {
        var value = fulfiller ? fulfiller.fulfillerId : sellers[index];
        var label = fulfiller ? fulfiller.fulfillerName : sellers[index];
        return {
          value: value,
          label: label
        };
      });
    }).catch(function () {
      return createDefaultSellers(sellers);
    });
  }).catch(function (res) {
    throw res;
  });
}

var doBulkEvaluateContracts =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(onGetAccessToken, isProduction, mcpSku, seller, buyers, evaluationParameters) {
    var outputFilter, body, accessToken, headers, options, productPriceUrl, response, json;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(0, _util.isEmptyArray)(buyers)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", [null]);

          case 2:
            outputFilter = ['price'];
            body = JSON.stringify({
              mcpSku: mcpSku,
              seller: seller,
              buyers: buyers,
              evaluationParameters: evaluationParameters,
              outputFilter: outputFilter
            });
            accessToken = onGetAccessToken();
            headers = new Headers({
              Accept: 'application/json',
              Authorization: "Bearer ".concat(accessToken),
              'Content-Type': 'application/json'
            });
            options = {
              method: 'POST',
              mode: 'cors',
              headers: headers,
              body: body
            };
            productPriceUrl = isProduction ? productionUrl : stgUrl;
            _context.next = 10;
            return fetch("".concat(productPriceUrl, "/api/v1/bulkevaluate"), options);

          case 10:
            response = _context.sent;

            if (!response.ok) {
              _context.next = 16;
              break;
            }

            _context.next = 14;
            return response.json();

          case 14:
            json = _context.sent;
            return _context.abrupt("return", json);

          case 16:
            return _context.abrupt("return", response);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function doBulkEvaluateContracts(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

exports.doBulkEvaluateContracts = doBulkEvaluateContracts;

var doBulkEvaluatePriceModel =
/*#__PURE__*/
function () {
  var _ref2 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(onGetAccessToken, isProduction, evaluationParameters, listPriceModel) {
    var outputFilter, priceModelId, revisionId, body, accessToken, headers, options, productPriceUrl, response, json;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (listPriceModel) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", {
              error: 'List Price is not configured for this sku'
            });

          case 2:
            outputFilter = ['price'];
            priceModelId = listPriceModel.priceModelId, revisionId = listPriceModel.revisionId;
            body = JSON.stringify({
              priceModelId: priceModelId,
              revisionId: revisionId,
              evaluationParameters: evaluationParameters,
              outputFilter: outputFilter
            });
            accessToken = onGetAccessToken();
            headers = new Headers({
              Accept: 'application/json',
              Authorization: "Bearer ".concat(accessToken),
              'Content-Type': 'application/json'
            });
            options = {
              method: 'POST',
              mode: 'cors',
              headers: headers,
              body: body
            };
            productPriceUrl = isProduction ? productionUrl : stgUrl;
            _context2.next = 11;
            return fetch("".concat(productPriceUrl, "/api/v1/bulkevaluate/publishedPriceModel"), options);

          case 11:
            response = _context2.sent;

            if (!response.ok) {
              _context2.next = 17;
              break;
            }

            _context2.next = 15;
            return response.json();

          case 15:
            json = _context2.sent;
            return _context2.abrupt("return", json);

          case 17:
            return _context2.abrupt("return", response);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function doBulkEvaluatePriceModel(_x7, _x8, _x9, _x10) {
    return _ref2.apply(this, arguments);
  };
}();

exports.doBulkEvaluatePriceModel = doBulkEvaluatePriceModel;

function bulkEval(_x11, _x12, _x13, _x14, _x15, _x16, _x17) {
  return _bulkEval.apply(this, arguments);
}

function _bulkEval() {
  _bulkEval = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3(onGetAccessToken, isProduction, mcpSku, evaluationParameters, fulfillerId, contracts, listPriceModel) {
    var buyers, seller, contractPromise, listPricePromise;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!((0, _util.isEmptyArray)(contracts) && !listPriceModel)) {
              _context3.next = 2;
              break;
            }

            throw new Error(NO_CONTRACTS_OR_LISTPRICE_MESSAGE);

          case 2:
            buyers = [];
            seller = {};

            if (!(0, _util.isEmptyArray)(contracts)) {
              contracts.forEach(function (contract) {
                if (contract && contract.seller && contract.seller.sellerId === fulfillerId && contract.buyer) {
                  buyers.push(contract.buyer);
                  seller = contract.seller;
                }
              });
            }

            contractPromise = doBulkEvaluateContracts(onGetAccessToken, isProduction, mcpSku, seller, buyers, evaluationParameters);
            listPricePromise = doBulkEvaluatePriceModel(onGetAccessToken, isProduction, evaluationParameters, listPriceModel);
            return _context3.abrupt("return", Promise.all([listPricePromise, contractPromise]).then(function (results) {
              var contractsResult = results[1];

              if (contractsResult && contractsResult.status) {
                contractsResult = buyers.map(function (buyer) {
                  var _contractsResult = contractsResult,
                      status = _contractsResult.status,
                      statusText = _contractsResult.statusText;
                  return {
                    buyer: buyer,
                    mcpSku: mcpSku,
                    status: status,
                    statusText: statusText
                  };
                });
              } // Normalize List Price results


              var listPriceResult = results[0];

              if (!listPriceResult || typeof listPriceResult !== 'object') {
                listPriceResult = {};
              }

              listPriceResult.mcpSku = mcpSku;
              listPriceResult.seller = seller;
              listPriceResult.buyer = {
                buyerType: 'merchants',
                buyerId: 'LIST PRICE'
              };
              return [listPriceResult].concat((0, _toConsumableArray2.default)(contractsResult));
            }));

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));
  return _bulkEval.apply(this, arguments);
}